import type { Order, OwnerOrder, Role } from "../shared/order-domain";
import { buildProfitSeries, PROFIT_RANGES, type ProfitRange } from "../shared/profit-domain";
import { renderProfitChart } from "./profit-chart";
import { element } from "./ui";

export function initializeProfitDialog(getOrders: () => readonly (Order | OwnerOrder)[], getRole: () => Role | null): { refresh(): void; reset(): void } {
  const dialog = element<HTMLDialogElement>("profitDialog");
  const ranges = element("profitRanges");
  const content = element("profitChart");
  let range: ProfitRange = 30;
  ranges.innerHTML = PROFIT_RANGES.map((days) => `<button type="button" class="filter${days === range ? " active" : ""}" data-profit-range="${days}" aria-pressed="${days === range}">最近${days}天</button>`).join("");

  function render(): void {
    content.innerHTML = renderProfitChart(buildProfitSeries(getOrders(), range));
    for (const button of ranges.querySelectorAll<HTMLButtonElement>("[data-profit-range]")) {
      const selected = Number(button.dataset.profitRange) === range;
      button.classList.toggle("active", selected);
      button.setAttribute("aria-pressed", String(selected));
    }
  }

  element("metrics").addEventListener("click", (event) => {
    if (!(event.target instanceof Element) || !event.target.closest("[data-profit-trend]") || getRole() !== "owner") return;
    render();
    dialog.showModal();
  });
  ranges.addEventListener("click", (event) => {
    const button = event.target instanceof Element ? event.target.closest<HTMLButtonElement>("[data-profit-range]") : null;
    const next = PROFIT_RANGES.find((days) => days === Number(button?.dataset.profitRange));
    if (next === undefined || getRole() !== "owner") return;
    range = next;
    render();
  });
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog || event.target instanceof Element && event.target.closest("[data-close]")) dialog.close();
  });

  function reset(): void {
    range = 30;
    content.replaceChildren();
    if (dialog.open) dialog.close();
  }

  return {
    refresh() {
      if (getRole() !== "owner") reset();
      else if (dialog.open) render();
    },
    reset,
  };
}
